import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import * as UserRoles from '../../config/UserRoles';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  public ErrorMsg = '';
  public editMode: boolean;

  public listOfUsers: Array<any>;
  public editingUser: User;
  public userRoles: any;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.editMode = false;
    this.userRoles = UserRoles;
    this.editingUser = new User();
    this.userService.getAllUsers().then((gym) => {
      this.listOfUsers = gym;
    });
  }

  addUser() {
    if (this.editingUser.username && this.editingUser.password) {
      this.userService.addUser(this.editingUser)
        .then(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name And Location Are Required.';
    }
  }

  delUser(id) {
    this.userService.delUser(id)
        .subscribe(() => { this.ngOnInit(); });
  }

  setUserToEdit(gym) {
    this.editMode = true;
    this.editingUser = gym;
  }

  quitEditingMode() {
    this.editMode = false;
    this.editingUser._id = null;
    this.editingUser.username = null;
    this.editingUser.password = null;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/user/user.component.ts